import { useEffect } from "react";
import CompMap from "./CompMap"; 

function AboutMap({ getLink, getData }) {
    useEffect(() => {
      getLink(window.location.href);
      getData(
        "오시는 길",
        "헬리오센 본사에 오시는 길을",
        "안내해드립니다."
      );
    }, [getLink, getData]);
    
    return(
        <div className="inner main-map">
            <h2 className="basic-title">오시는 길</h2>
            <div className="basic-subtitle">헬리오센의 위치입니다.</div>
            <div>
                <div className="map-info-wrap">
                    <div className="map-info-txt-wrap">
                        <h2 className="map-info-txt">회사정보</h2>
                    </div>
                    <div className="map-info">
                        <ul className="map-info-list">
                            <li className="map-info-item map-info-line-item">
                                <h2 className="map-info-title">주소</h2>
                                <p className="map-info-subtitle">경기 성남시 분당구 판교역로 230 삼환하이펙스 B동 B101호</p>
                            </li>
                            <li className="map-info-item map-info-line-item">
                                <h2 className="map-info-title">전화번호</h2>
                                <p className="map-info-subtitle">+82) 031-697-0610</p>
                            </li>
                            <li className="map-info-item">
                                <h2 className="map-info-title">이메일</h2>
                                <p className="map-info-subtitle">heliosen@heliosen.co.kr</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <CompMap/>
                <div className="map-info-wrap map-method">
                    <h2 className="map-info-title">오시는 방법</h2>
                    <div className="map-info-subtitle">
                        <p>H스퀘어.삼환하이펙스(버스정류장): 602-1A, 602-1B, 602-2B, 9007, 101, 390, 66, 73</p>
                        <p>판교역(지하철)</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutMap;